import React from "react";
import { CheckCircle } from "react-feather";
import {
  getLicensePrice,
  getLicenseFee,
  getLicenseTotalPrice,
  formatPrice,
} from "../../../utilities";

const LicenseRequestSent = ({ status, note, royalties, totalPrice }) => (
  <div className="license-buttons">
    {status === "PENDING" && (
      <button type="button" className="btn btn-primary mb-1" disabled>
        <i className="icon-handshake" />
        Pending acceptance
      </button>
    )}
    {status === "DECLINED" && (
      <div className="btn license-declined" disabled>
        Declined offer
      </div>
    )}
    {status === "ACCEPTED" && (
      <div className="btn license-accepted">
        <CheckCircle size={15} className="me-1" />
        Status: Creator Accepted
      </div>
    )}
    {status === "PENDING" && (
      <span>
        {`You will be charged ${formatPrice(getLicensePrice(note))} +
              ${formatPrice(
                getLicenseFee(getLicensePrice(note))
              )} (Vyrill fee) for a total of
              ${formatPrice(
                getLicenseTotalPrice(note)
              )}, if the creator accepts.`}
      </span>
    )}
    {status === "ACCEPTED" && (
      <span>
        {`You will be charged ${formatPrice(royalties)} +
              ${formatPrice(
                getLicenseFee(royalties)
              )} (Vyrill fee) for a total of
              ${formatPrice(totalPrice)}, if the creator accepts.`}
      </span>
    )}
  </div>
);

export default LicenseRequestSent;
